const state = {
  userEdit: null,
  userMap: null
}

export default state